<template>
    <AppActionBase bg="transparent" icon-url="/assets/icons/edit.svg" alt="Edit"
        :custom-class="`btn-edit-style ${customClass}`" v-bind="$attrs" @click="$emit('click', $event)" />
</template>

<script>
import AppActionBase from './AppActionBase.vue';

export default {
    name: 'AppActionEdit',
    components: {
        AppActionBase
    },
    props: {
        customClass: {
            type: String,
            default: ''
        }
    },
    emits: ['click']
}
</script>
